import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import NumberFormat from "react-number-format";
import { Row, Typography } from "antd";
import { Spin } from "antd";
import cubejsApi from "../../../cubejsApiBQ";

const { Title } = Typography;

const cantRender2 = ({ resultSet, props }) => {
    const name = [
        "BaseResumenColocacion.cantidadEstadoFuelles",
        "BaseResumenColocacion.cantidadEstadoRadicado",
        "BaseResumenColocacion.cantidadEstadoDevuelto",
        "BaseResumenColocacion.cantidadEstadoPreaprobado",
    ];
    return (
        <Row gutter={[0, 0]} type="flex" justify="center">
            <Title
                style={{
                    fontSize: "14px",
                }}
            >
                <NumberFormat
                    value={resultSet.loadResponse.data[0][name[props.index]]}
                    decimalScale={0}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"#"}
                />
            </Title>
        </Row>
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const CantRender2 = (props) => {
    return (
        <QueryRenderer
            query={{
                renewQuery: true,
                measures: [
                    "BaseResumenColocacion.cantidadEstadoFuelles",
                    "BaseResumenColocacion.cantidadEstadoRadicado",
                    "BaseResumenColocacion.cantidadEstadoDevuelto",
                    "BaseResumenColocacion.cantidadEstadoPreaprobado",
                ],
                timeDimensions: [],
                dimensions: [],
                segments: [],
                filters: [
                    {
                        dimension: "BaseResumenColocacion.fechaCorte",
                        operator: "contains",
                        values: props.fecha !== "" ? [props.fecha] : [],
                    },
                    {
                        dimension: "Usuarios.idCedula",
                        operator: "contains",
                        values: props.cedula !== "" ? [props.cedula] : [],
                    },
                    {
                        dimension: "BaseResumenColocacion.zona",
                        operator: "contains",
                        values: props.zona !== "" ? [props.zona] : [],
                    },
                ],
            }}
            cubejsApi={cubejsApi}
            render={renderChart(cantRender2, props)}
        />
    );
};

export default CantRender2;
